export default __webpack_public_path__ + "static/media/laspalmas.aa77177f.jpeg";